import React from 'react';
import { Helmet } from 'react-helmet';

export class ProductDetailHelmet extends React.Component {
  constructor(props) {
    super(props);
  }
  shouldComponentUpdate(nextProps) {
    return !_.isEqual(this.props, nextProps);
  }
  render() {
    var productJsonLd = {};
    if (
      this.props.contentData &&
      typeof this.props.contentData == 'object' &&
      this.props.contentData.productLayout &&
      this.props.contentData.productLayout != 'BundleDisplay' &&
      this.props.contentData.productLayout != 'OutfitDisplay' &&
      this.props.contentData.productLayout != 'QuickViewError' &&
      this.props.contentData.productLayout != 'QuickViewNotAvailable' &&
      this.props.contentData.productLayout != 'OldProduct' &&
      this.props.contentData.productLayout != 'NotAvailable'
    ) {
      productJsonLd['@context'] = 'http://schema.org/';
      productJsonLd['@type'] = 'Product';
      productJsonLd['@id'] =
        `https://` + this.props.passedAppFunctions.wasParms.domainName + this.props.passedAppFunctions.navState;
      productJsonLd.description = this.props.contentData.longDescription
        ? this.props.contentData.longDescription.split('#double;').join('"').replaceAll(/<.*?>/g, ' ')
        : '';
      productJsonLd.productID = this.props.contentData.partNumber;
      productJsonLd.sku = this.props.contentData.style;
      productJsonLd.brand = {};
      productJsonLd.brand['@type'] = 'Brand';
      productJsonLd.brand.name = this.props.contentData.brandNameForTitle;
      productJsonLd.image =
        'https:' + (this.props.contentData.fullImage ? this.props.contentData.fullImage.imageName : '');
      productJsonLd.name = this.props.contentData.originalProductName;
      if (
        this.props.contentData.reviewCount &&
        this.props.contentData.reviewCount > 0 &&
        this.props.contentData.reviewStars
      ) {
        productJsonLd.aggregateRating = {};
        productJsonLd.aggregateRating['@type'] = 'AggregateRating';
        productJsonLd.aggregateRating.reviewCount = this.props.contentData.reviewCount;
        productJsonLd.aggregateRating.ratingValue = this.props.contentData.reviewStars;
      }
      productJsonLd.offers = {};
      productJsonLd.offers['@type'] = 'AggregateOffer';
      productJsonLd.offers.priceCurrency = 'USD';
      if (this.props.contentData.limitedAvailability) {
        productJsonLd.offers.availability = 'http://schema.org/LimitedAvailability';
      } else if (this.props.contentData.pricing) {
        productJsonLd.offers.availability = 'http://schema.org/InStock';
      } else {
        productJsonLd.offers.availability = 'http://schema.org/OutOfStock';
      }
      if (this.props.contentData.pricing) {
        productJsonLd.offers.lowPrice = this.props.contentData.pricing.offerPriceMin.replace(',', '');
        productJsonLd.offers.highPrice = this.props.contentData.pricing.offerPriceMax.replace(',', '');
      }
      if (!(this.props.contentData.limitedAvailability || this.props.contentData.pricing)) {
        productJsonLd.offers.offerCount = ' ';
      }
      if (!(this.props.contentData.limitedAvailability || this.props.contentData.pricing)) {
        productJsonLd.offers.lowPrice = '';
      }
      productJsonLd.offers.offers = [];
      for (var i = 0; i < (this.props.contentData.itemInfo || []).length; i++) {
        var thisItem = this.props.contentData.itemInfo[i];
        var thisItemJson = {};
        thisItemJson['@type'] = 'Offer';
        let catentryId = '';
        for (let i = 0; i < (this.props.contentData.skus || []).length; i++) {
          if (thisItem.sku == this.props.contentData.skus[i].partnumber)
            catentryId = this.props.contentData.skus[i].catentryId;
        }
        let field2 = '';
        for (let i = 0; i < (thisItem.attributes || []).length; i++) {
          if (field2.length > 0) field2 += '|';
          field2 += thisItem.attributes[i].attrName;
          field2 += ':';
          field2 += thisItem.attributes[i].attrValue;
        }
        thisItemJson.checkoutPageURLTemplate = `https://${this.props.passedAppFunctions.wasParms.domainName}/webapp/wcs/stores/servlet/OrderItemAdd?catEntryId=${catentryId}&productId=${this.props.contentData.productId}&description=${this.props.contentData.partNumber}|${this.props.contentData.productId}|PP-PIP&quantity=1&field2=${field2}`;
        thisItemJson.availability = this.props.contentData.limitedAvailability
          ? 'http://schema.org/LimitedAvailability'
          : 'http://schema.org/InStock';
        thisItemJson.itemCondition = 'http://schema.org/NewCondition';
        thisItemJson.hasMerchantReturnPolicy = {};
        thisItemJson.hasMerchantReturnPolicy['@type'] = 'MerchantReturnPolicy';
        thisItemJson.hasMerchantReturnPolicy.applicableCountry = 'US';
        thisItemJson.hasMerchantReturnPolicy.returnPolicyCategory = 'https://www.dillards.com/c/returns';
        thisItemJson.hasMerchantReturnPolicy.merchantReturnDays =
          this.props.contentData.pricing && this.props.contentData.pricing.markDown == 'P' ? '' : 30;
        thisItemJson.hasMerchantReturnPolicy.returnMethod = 'https://www.dillards.com/c/returns';
        thisItemJson.hasMerchantReturnPolicy.returnFees = 'https://www.dillards.com/c/returns';
        thisItemJson.itemOffered = {};
        thisItemJson.itemOffered['@type'] = 'Product';
        for (var j = 0; j < (thisItem.attributes || []).length; j++) {
          if (thisItem.attributes[j].attrName == 'Color') {
            thisItemJson.itemOffered.color = thisItem.attributes[j].attrValue;
          }
        }
        thisItemJson.itemOffered.mpn = thisItem.upc;
        thisItemJson.itemOffered.name = this.props.contentData.originalProductName;
        thisItemJson.itemOffered.sku = thisItem.sku;

        thisItemJson.itemOffered.image =
          'https:' +
          (thisItem.image
            ? thisItem.image
            : this.props.contentData.fullImage
              ? this.props.contentData.fullImage.imageName
              : '');

        thisItemJson.itemOffered.description = this.props.contentData.longDescription
          ? this.props.contentData.longDescription.split('#double;').join('"').replaceAll(/<.*?>/g, ' ')
          : '';
        thisItemJson.itemOffered.brand = {};
        thisItemJson.itemOffered.brand['@type'] = 'Brand';
        thisItemJson.itemOffered.brand.name = this.props.contentData.brandNameForTitle;

        if (
          this.props.contentData.reviewCount &&
          this.props.contentData.reviewCount > 0 &&
          this.props.contentData.reviewStars
        ) {
          thisItemJson.itemOffered.aggregateRating = {};
          thisItemJson.itemOffered.aggregateRating['@type'] = 'AggregateRating';
          thisItemJson.itemOffered.aggregateRating.reviewCount = this.props.contentData.reviewCount;
          thisItemJson.itemOffered.aggregateRating.ratingValue = this.props.contentData.reviewStars;
        }

        thisItemJson.itemOffered.offers = {};
        thisItemJson.itemOffered.offers['@type'] = 'Offer';
        thisItemJson.itemOffered.offers.availability = this.props.contentData.limitedAvailability
          ? 'http://schema.org/LimitedAvailability'
          : 'http://schema.org/InStock';
        thisItemJson.itemOffered.offers.itemCondition = 'http://schema.org/NewCondition';
        thisItemJson.itemOffered.offers.price = thisItem.offerPrice;
        thisItemJson.itemOffered.offers.priceCurrency = 'USD';

        thisItemJson.price = thisItem.offerPrice;
        thisItemJson.priceCurrency = 'USD';
        if (this.props.passedAppFunctions.navState && this.props.passedAppFunctions.navState.split('/')[2]) {
          thisItemJson.itemOffered.offers.url = `https://${this.props.passedAppFunctions.wasParms.domainName}/p/${this.props.passedAppFunctions.navState.split('/')[2]}/${this.props.contentData.productId}`;
        } else {
          thisItemJson.itemOffered.offers.url = `https://${this.props.passedAppFunctions.wasParms.domainName}/p/${this.props.contentData.originalProductName.toLowerCase().split(' ').join('-')}/${this.props.contentData.productId}`;
        }

        productJsonLd.offers.offers.push(thisItemJson);
      }
    }

    var helmetProperties = {};
    helmetProperties.meta = [];
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogTitle) {
      helmetProperties.meta.push({
        property: 'og:title',
        content: this.props.contentData.seo.ogTitle.split('#double;').join('"'),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogDescription) {
      helmetProperties.meta.push({
        property: 'og:description',
        content: this.props.contentData.seo.ogDescription
          .split('#double;')
          .join('"')
          .replace(/Dillards.com/g, "Dillard's"),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogUrl) {
      helmetProperties.meta.push({
        property: 'og:url',
        content: this.props.contentData.seo.ogUrl.split('#double;').join('"'),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogType) {
      helmetProperties.meta.push({
        property: 'og:type',
        content: this.props.contentData.seo.ogType.split('#double;').join('"'),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogLocale) {
      helmetProperties.meta.push({
        property: 'og:locale',
        content: this.props.contentData.seo.ogLocale.split('#double;').join('"'),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogImage) {
      helmetProperties.meta.push({ property: 'og:image', content: this.props.contentData.seo.ogImage });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.productPriceAmount) {
      helmetProperties.meta.push({
        property: 'product:price:amount',
        content: this.props.contentData.seo.productPriceAmount,
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.productPriceCurrency) {
      helmetProperties.meta.push({
        property: 'product:price:currency',
        content: this.props.contentData.seo.productPriceCurrency,
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.description) {
      helmetProperties.meta.push({
        name: 'description',
        content: this.props.contentData.seo.description.split('#double;').join('"'),
      });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.title) {
      helmetProperties.title = this.props.contentData.seo.title.split('#double;').join('"');
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.keywords) {
      helmetProperties.meta.push({
        name: 'keywords',
        content: this.props.contentData.seo.keywords.split('#double;').join('"'),
      });
    }
    if (
      (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.noindex) ||
      this.props.passedAppFunctions.navState.indexOf('inf=') > -1
    ) {
      helmetProperties.meta.push({ name: 'robots', content: 'noindex' });
    }
    if (this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.canonical) {
      if (this.props.passedAppFunctions.navState.indexOf('inf=') > -1) {
        helmetProperties.link = [{ rel: 'canonical', href: this.props.passedAppFunctions.navState }];
      } else {
        helmetProperties.link = [{ rel: 'canonical', href: this.props.contentData.seo.canonical }];
      }
    }

    return (
      <React.Fragment>
        <Helmet {...helmetProperties} />
        {/* <Helmet>
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogTitle ?
							<meta property="og:title" content={this.props.contentData.seo.ogTitle.split('#double;').join('"')} />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogDescription ?
							<meta property="og:description" content={this.props.contentData.seo.ogDescription.split('#double;').join('"')} />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.ogImage ?
							<meta property="og:image" content={this.props.contentData.seo.ogImage} />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.description ?
							<meta name="description" content={this.props.contentData.seo.description.split('#double;').join('"')} />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.title ?
							<title>{this.props.contentData.seo.title.split('#double;').join('"')}</title>
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.keywords ?
							<meta name="keywords" content={this.props.contentData.seo.keywords.split('#double;').join('"')} />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.noindex ?
							<meta name="robots" content="noindex" />
							: ''
					}
					{
						this.props.contentData && this.props.contentData.seo && this.props.contentData.seo.canonical ?
							<link rel="canonical" href={this.props.contentData.seo.canonical} />
							: ''
					}
				</Helmet> */}
        <script
          suppressHydrationWarning={true}
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(productJsonLd) }}
        ></script>
      </React.Fragment>
    );
  }
}

export default ProductDetailHelmet;
